<template>
  <div style="width: 100%; height: 100%; color: #555">
    <div
      style="overflow-x: hidden"
      class="containerPedidos scrollPersonalizadoWH"
    >
      <!-- Botões de alternância de visualização -->
      <div class="d-flex justify-content-center mb-3">
        <b-button-group>
          <b-btn
            :variant="tipoVisu == 'Pedidos' ? 'primary' : 'outline-primary'"
            @click="tipoVisu = 'Pedidos'"
          >
            <i class="fa fa-list"></i> Por Pedido
          </b-btn>
          <b-btn
            :variant="tipoVisu == 'Produtos' ? 'primary' : 'outline-primary'"
            @click="tipoVisu = 'Produtos'"
          >
            <i class="fa fa-cube"></i> Por Produto
          </b-btn>
        </b-button-group>
      </div>

      <div
        class="d-flex justify-content-between mb-2"
        v-if="!fechado && !isMobile"
      >
        <div class="d-flex justify-content-start flex-column flex-md-row mb-2">
          <b-btn
            :size="isMobile ? 'lg' : ''"
            variant="info"
            class="mr-1 mt-2 text-lg-left text-center"
            @click="addPedido"
          >
            <i class="fa fa-shopping-cart"></i> Adicionar Item
          </b-btn>

          <b-btn
            v-if="showButtons"
            :size="isMobile ? 'lg' : ''"
            variant="danger"
            class="mr-1 mt-2 text-lg-left text-center"
            @click="removeTaxa"
            ><b-icon-percent />
            <span> Alterar Taxa</span>
          </b-btn>
          <b-btn
            v-if="showButtons"
            :size="isMobile ? 'lg' : ''"
            variant="success"
            class="mr-1 mt-2 text-lg-left text-center"
            @click="addPgto"
            ><b-icon-currency-dollar />
            <span v-if="!isMobile"> Adicionar Pagamento</span>
          </b-btn>
        </div>
        <b-btn
          :size="isMobile ? 'lg' : ''"
          variant="primary"
          class="mr-1 mt-2 text-lg-left text-center"
          @click="fecharMesa"
        >
          <i class="fas fa-clipboard-check"></i> Fechar
          {{ comandaSel ? "Comanda" : termoMesa }}
        </b-btn>
      </div>
      <div v-if="fechado && !isMobile" class="d-flex justify-content-end mb-2">
        <b-btn
          :size="isMobile ? 'lg' : ''"
          variant="warning"
          class="mr-1 mt-2 text-lg-left text-center"
          @click="reabrirMesa"
        >
          <i class="fas fa-folder-open"></i> Reabrir
          {{ comandaSel ? "Comanda" : termoMesa }}
        </b-btn>
      </div>

      <!-- Visualização por Pedido -->
      <div class="row">
        <div class="col-12 col-md-7 pr-0 pr-sm-1 pl-0 pl-sm-3">
          <div v-if="tipoVisu == 'Pedidos'">
            <div
              v-if="!pedidosPorPedido || pedidosPorPedido.length <= 0"
              class="p-2 text-center"
            >
              Nenhum pedido adicionado ainda.
            </div>
            <div
              v-for="p in pedidosPorPedido"
              :key="`ped_${p.qt}`"
              class="pedido"
              :class="p.itens[0].excluido === 1 ? '' : ''"
            >
              <b-card>
                <b-card-title>
                  <div class="d-flex justify-content-between">
                    <div>
                      <i class="fa fa-barcode mr-1" />
                      {{ ` ${getComandaNome(p.comanda, 0) || ""}` }}
                      <br v-if="$store.state.isMobile" />
                      <span
                        v-if="
                          getComandaNome(p.comanda, 1) &&
                          getComandaNome(p.comanda, 1).trim() != ''
                        "
                        class="ml-2"
                        style="font-size: 10px"
                      >
                        <i class="fa fa-user mr-1" />
                        {{ getComandaNome(p.comanda, 1) || "" }}
                        <i class="fa fa-phone ml-2 mr-1" />
                        {{ getComandaNome(p.comanda, 2) || "" }}
                      </span>
                    </div>
                    <div>
                      <b-btn
                        @click="$emit('trocarMesaComanda', p)"
                        v-if="
                          (comandaSel && !comandaSel.dt_fechada) || !comandaSel
                        "
                      >
                        <i class="fas fa-exchange-alt"></i>
                      </b-btn>
                    </div>
                  </div>
                </b-card-title>
                <b-card-sub-title class="mb-4" style="font-size: 12px">
                  <b-icon-person class="mr-1" v-if="p.usuario" />{{
                    `${p.usuario || ""} `
                  }}
                  <b-icon-clock class="mr-1" />
                  {{ p.data | moment("DD/MM/YYYY HH:mm") }}
                </b-card-sub-title>
                <div
                  v-for="it in p.itens"
                  :key="`it_${p.qt}_${it.cnt}`"
                  class="item"
                  :class="it.excluido === 1 ? 'pedidoCancelado' : ''"
                  @click="openItem(it)"
                >
                  <div>
                    - {{ it.quantidade }} x {{ it.prod }}
                    {{ it.prod2 && it.prod2 != "" ? " / " + it.prod2 : "" }}
                    {{
                      it.borda && it.borda != "" ? " - Borda " + it.borda : ""
                    }}
                    <span
                      v-if="it.excluido === 1"
                      style="color: red !important"
                      class="ml-3"
                    >
                      <b-icon-trash /> EXCLUIDO
                    </span>
                    <div style="font-size: 8px" class="pl-4">
                      <i class="fa fa-headset mr-1" /> {{ it.usuario }}
                      <b-icon-clock class="ml-1" />
                      {{ it.data | moment("DD/MM/YYYY HH:mm") }}
                    </div>
                  </div>
                  <div
                    class=""
                    style="
                      align-self: self-end;
                      min-width: 60px;
                      text-align: right;
                    "
                  >
                    <b-btn
                      v-if="
                        it.prod && it.prod.toUpperCase().indexOf('ROD') >= 0
                      "
                      size="sm"
                      v-b-tooltip.hover
                      title="IMPRIMIR COMPROVANTE SAIDA"
                      class="mr-2"
                      variant="info"
                      @click.stop="imprimeComprovanteSaida(it)"
                    >
                      <b-icon-check />
                    </b-btn>
                    <small class="mr-2"
                      ><small
                        >({{ it.quantidade }} x
                        {{ it.vl_unitario | currency }})</small
                      ></small
                    >
                    {{ it.vl_total | currencyMask }}
                  </div>
                </div>
                <div class="mt-4">
                  <b
                    >Total
                    <div class="float-right">
                      {{ p.vl | currencyMask }}
                    </div>
                  </b>
                </div>
              </b-card>
            </div>
          </div>

          <!-- Visualização por Produto -->
          <div class="row" v-if="tipoVisu == 'Produtos'">
            <div class="col-12 px-0 mx-1 px-lg-3 mx-lg-1">
              <div
                v-if="!pedidosPorProduto || pedidosPorProduto.length <= 0"
                class="p-2 text-center"
              >
                Nenhum pedido adicionado ainda.
              </div>

              <div
                v-for="prod in pedidosPorProduto"
                :key="`prod_${prod.cod_produto}`"
                class="pedido-produto my-0 mx-1"
                @click="abrirModalProduto(prod)"
              >
                <b-card>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <h6 class="mb-1">
                        <b-avatar
                          v-if="prod.img"
                          :src="prod.img"
                          size="40"
                          class="mr-2 align-middle"
                        />
                        {{ prod.nome }}
                      </h6>
                    </div>
                    <div class="text-right">
                      <div
                        style="
                          font-size: 15px;
                          font-weight: bold;
                          color: #28a745;
                        "
                      >
                        <div class="text-gray">
                          <small style="color: #444">
                            {{ prod.quantidadeTotal }} x
                            {{ prod.valor_unitario | currency }}
                          </small>
                        </div>
                        {{ prod.valorTotal | currencyMask }}
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
            </div>
            <div class="col-12 mt-4 text-right">
              <hr />
              <b>Total dos Produtos:</b>
              <span style="font-size: 18px; font-weight: bold; color: #28a745">
                {{
                  pedidosPorProduto.reduce(
                    (acc, prod) => acc + prod.valorTotal,
                    0
                  ) | currencyMask
                }}
              </span>
            </div>
          </div>

          <div
            :class="`btPlus text-center`"
            @click="addPedido()"
            v-if="
              (comandaSel && !comandaSel.dt_fechada) ||
              (!comandaSel && !mesaObj.dt_fechada)
            "
          >
            <i class="fa fa-plus" />
          </div>
        </div>

        <div class="col-12 col-md-5 pl-0 pl-sm-1" v-if="!isMobile">
          <mesa-new-pedido-resumo
            :mesaObj="mesaObj"
            :mesaVisu="mesaVisu"
            :getMesaNome="getMesaNome"
            :comanda="comandaSel"
            @addPgto="addPgto"
            @removerTaxa="removeTaxa()"
            :showFechar="(comandaSel && !comandaSel.dt_fechada) || !comandaSel"
            :showButtons="(comandaSel && !comandaSel.dt_fechada) || !comandaSel"
            @fecharMesa="fecharMesa"
            @gotoPG="gotoPG"
            @addItem="addPedido"
            @addPagamento="addPagamento"
            :editPagamento="editPagamento"
            :showPagamentos="true"
            :reabrirMesa="reabrirMesa"
          />
        </div>
      </div>

      <!-- Modal de detalhes do produto -->
      <b-modal
        v-model="showModalProduto"
        :title="`Detalhes: ${produtoSelecionado.nome}`"
        size="lg"
        centered
        hide-footer
      >
        <div v-if="produtoSelecionado">
          <div
            class="mb-3 p-3"
            style="background-color: #f8f9fa; border-radius: 5px"
          >
            <div class="row">
              <div class="col-6">
                <strong>Quantidade Total:</strong>
                {{ produtoSelecionado.quantidadeTotal }}
              </div>
              <div class="col-6 text-right">
                <strong>Valor Total:</strong>
                {{ produtoSelecionado.valorTotal | currencyMask }}
              </div>
            </div>
          </div>
          <div
            v-if="
              produtoSelecionado &&
              produtoSelecionado.pedidos &&
              produtoSelecionado.pedidos.length > 0
            "
          >
            <b-btn
              size="sm"
              variant="primary"
              class="mb-1"
              block
              @click="duplicarPedidoModal(produtoSelecionado.pedidos[0])"
              v-if="
                produtoSelecionado &&
                produtoSelecionado.pedidos.length > 0  
              "
            >
              <i class="fa fa-copy"></i> Duplicar
            </b-btn>
          </div>
          

          <div
            v-for="(ped, index) in produtoSelecionado.pedidos"
            :key="`modal_ped_${index}`"
            class="pedido-item-modal mb-3"
          >
            <b-card>
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <div class="mb-2">
                    <b-icon-person class="mr-1" />
                    <strong>{{ ped.usuario }}</strong>
                  </div>
                  <div style="font-size: 12px; color: #666" class="mb-2">
                    <b-icon-clock class="mr-1" />
                    {{ ped.data | moment("DD/MM/YYYY HH:mm") }}
                  </div>
                  <div style="font-size: 12px" class="mb-2">
                    <b-icon-hash class="mr-1" />
                    {{ getComandaNome(ped.comanda, 0) }}
                  </div>
                  <div>
                    <strong>Quantidade:</strong> {{ ped.quantidade }} x
                    {{ ped.vl_unitario | currency }}
                  </div>
                  <div v-if="ped.excluido === 1" class="text-danger mt-2">
                    <b-icon-trash /> CANCELADO
                  </div>
                </div>
                <div class="text-right">
                  <div
                    style="
                      font-size: 16px;
                      font-weight: bold;
                      margin-bottom: 10px;
                    "
                  >
                    {{ ped.vl_total | currencyMask }}
                  </div>
                  <div class="btn-group-vertical">
                    <b-btn
                      size="sm"
                      variant="primary"
                      class="mb-1"
                      @click="duplicarPedidoModal(ped)"
                      v-if="!ped.excluido || ped.excluido === 0"
                    >
                      <i class="fa fa-copy"></i> Duplicar
                    </b-btn>
                    <b-btn
                      size="sm"
                      variant="danger"
                      @click="cancelarPedidoModal(ped)"
                      v-if="!ped.excluido || ped.excluido === 0"
                    >
                      <b-icon-trash /> Cancelar
                    </b-btn>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="text-right mt-3">
          <b-btn variant="secondary" @click="showModalProduto = false">
            Fechar
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import MesaNewPedidoResumo from "./MesaNewPedidoResumo.vue";
import Pedido from "../../libs/Pedido";
export default {
  components: { MesaNewPedidoResumo },
  props: {
    mesaObj: Object,
    mesaVisu: Number,
    getMesaNome: Function,
    addPedido: Function,
    comandaSel: Object,
    addPagamento: Function,
    editPagamento: Function,
    data: [Object, String],
    blocked: Boolean,
    reabrirMesa: Function,
    empresaSel: Object,
  },
  mounted() {
    this.calc();
    // console.log("ms", this.mesaObj);
  },
  data() {
    return {
      // pedidosPorPedido: [],
      tipoVisu: "Produtos",
      showFechar:
        (this.comandaSel && !this.comandaSel.dt_fechada) || !this.comandaSel,
      showButtons: true,
      isMobile: this.$store.state.isMobile,
      showModalProduto: false,
      produtoSelecionado: {
        nome: "",
        quantidadeTotal: 0,
        valorTotal: 0,
        pedidos: [],
      },
    };
  },
  watch: {
    mesaObj: {
      deep: true,
      handler() {
        console.log("change", this.mesaObj);
        this.calc();
        this.$forceUpdate();
      },
    },
    comandaSel: function () {
      // console.log("change1", this.comandaSel);
      this.$forceUpdate();
    },
  },
  computed: {
    fechado() {
      return this.comandaSel
        ? this.comandaSel.dt_fechada
        : this.mesaObj.dt_fechada;
    },
    pedidos() {
      return this.mesaObj.pedidos
        .filter(
          (x) =>
            (this.mesaVisu ? x.cod_mesa == this.mesaVisu : true) &&
            (this.comandaSel ? x.comanda_id == this.comandaSel.id : true)
        )
        .reduce((ret, vl) => {
          let hasProd = ret.find(
            (x) =>
              x.cod_produto == vl.cod_produto && x.cod_pedido == vl.cod_pedido
          );
          if (!hasProd) {
            ret.push({ ...vl, lst: [vl] });
          } else {
            if (
              !hasProd.lst.some((x) => x.cod_pedido_item == vl.cod_pedido_item)
            ) {
              hasProd.quantidade += vl.quantidade;
              hasProd.vl_total += vl.vl_total;
            }
          }
          return ret;
        }, []);
    },
    pedidosPorPedido() {
      console.log("p", this.mesaObj.pedidos);
      let peds = [...this.mesaObj.pedidos].sort((a,b) => b.cod_pedido - a.cod_pedido)
        .filter(
          (x) =>
            (this.mesaVisu ? x.cod_mesa == this.mesaVisu : true) &&
            (this.comandaSel ? x.comanda_id == this.comandaSel.id : true)
        )
        .reduce((ret, vl) => {
          let has = ret.find((x) => x.comanda == vl.comanda);
          let it = vl;
          if (!has) {
            ret.push({
              comanda_id: vl.comanda_id,
              comanda: vl.comanda,
              itens: [it],
              qt: ret.length + 1,
              vl: !vl.excluido || vl.excluido == 0 ? vl.vl_total : 0,
              usuario: vl.usuario,
              data: vl.data,
              vl_un: vl.vl_unitario,
              cod_pedido: vl.cod_pedido,
            });
          } else {
            has.itens.push(it);
            if (!vl.excluido || vl.excluido == 0) has.vl += vl.vl_total;
          }
          return ret;
        }, []);

      for (let p of peds) {
        p.itens = p.itens.reduce((ret, vl) => {
          let hasProd = ret.find(
            (x) =>
              x.cod_produto == vl.cod_produto && x.cod_pedido == vl.cod_pedido
          );
          if (!hasProd) {
            ret.push({ ...vl, lst: [vl] });
          } else {
            if (
              !hasProd.lst.some((x) => x.cod_pedido_item == vl.cod_pedido_item)
            )
              hasProd.quantidade += vl.quantidade;
            hasProd.vl_total += vl.vl_total;
          }
          return ret;
        }, []);
      }
      console.log("peds", peds);
      return peds;
    },
    pedidosPorProduto() {
      let pedidos = [...this.mesaObj.pedidos].sort((a,b) => b.cod_pedido - a.cod_pedido).filter(
        (x) =>
          (this.mesaVisu ? x.cod_mesa == this.mesaVisu : true) &&
          (this.comandaSel ? x.comanda_id == this.comandaSel.id : true)
      );

      // Agrupar por produto
      let produtosAgrupados = pedidos.reduce((ret, pedido) => {
        let produtoKey = pedido.cod_produto;
        let produto = ret.find((p) => p.cod_produto === produtoKey);

        if (!produto) {
          ret.push({
            cod_produto: pedido.cod_produto,
            nome: pedido.prod,
            img: pedido.img,
            quantidadeTotal:
              !pedido.excluido || pedido.excluido == 0 ? pedido.quantidade : 0,
            valorTotal:
              !pedido.excluido || pedido.excluido == 0 ? pedido.vl_total : 0,
            valor_unitario: pedido.vl_unitario,
            pedidos: [pedido],
          });
        } else {
          if (!pedido.excluido || pedido.excluido == 0) {
            produto.quantidadeTotal += pedido.quantidade;

            produto.valorTotal += pedido.vl_total;
          }
          produto.pedidos.push(pedido);
        }

        return ret;
      }, []);

      // Ordenar por nome do produto
      produtosAgrupados.sort((a, b) => a.nome.localeCompare(b.nome));

      console.log("produtosAgrupados", produtosAgrupados);
      return produtosAgrupados;
    },
  },
  methods: {
    gotoPG() {
      this.$emit("gotoPG");
    },
    getComandaNome(nome, index) {
      if (nome && nome.includes("|")) {
        return nome.split("|")[index];
      } else {
        return nome;
      }
    },
    calc() {
      // this.pedidosPorPedido =
    },
    addPgto() {
      this.$emit("addPgto");
    },
    removeTaxa() {
      console.log("removeTaxa 1");
      this.$emit("removeATaxa");
    },
    imprimeComprovanteSaida(it) {
      console.log("item", it);
      this.$emit("comprovanteSaida", it);

      this.showToast("success", "Impressão de Comprovante de Saida solicitado");
    },
    fecharMesa() {
      if (
        (!this.mesaObj.dt_fechada &&
          this.comandaSel &&
          !this.comandaSel.dt_fechada) ||
        !this.comandaSel
      ) {
        console.log("fechar02");

        this.$emit("fecharMesa");
      }
    },
    openItem(it) {
      console.log("it", it);
      if (this.comandaSel && this.comandaSel.dt_fechada) return;
      this.$swal({
        title: "Ação no Item",
        text: `O que deseja fazer com o item ${it.prod}?`,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Duplicar`,
        denyButtonText: `Cancelar`,
        cancelButtonText: `Fechar`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          var duplicatingSwal = this.$swal({
            title: "Duplicando aguarde...",
            html: `
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <svg width="40" height="40" viewBox="0 0 40 40" style="margin-bottom: 10px;" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <circle cx="20" cy="20" r="18" stroke="#3498db" stroke-width="4" opacity="0.2"/>
                  <circle cx="20" cy="20" r="18" stroke="#3498db" stroke-width="4" stroke-linecap="round"
                    stroke-dasharray="90 60"
                    stroke-dashoffset="0">
                    <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="1s" repeatCount="indefinite"/>
                  </circle>
                  </svg>
                  Aguarde o sistema duplicar o item <hr/> <li>${it.prod}</li>
                </div>
                `,
            toast: true,
            width: "300px",
            heightAuto: true,
            icon: "info",
            showConfirmButton: false,
            textAlign: "center",
            showButtons: false,
            showCloseButton: false,
          });
          let result = await Pedido.duplicar({
            cod_pedido: it.cod_pedido,
            cod_pedido_item: it.cod_pedido_item,
            empresa: this.empresaSel.codigo,
          });
          console.log("dup result", result);
          this.$emit("carregar");

          duplicatingSwal.close();
          this.showToast("success", `Item ${it.prod} duplicado com sucesso!`);
        } else if (result.isDenied) {
          await this.$swal({
            title: "Confirmação",
            text: "Você tem certeza que deseja cancelar este pedido?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim! Cancelar.",
            cancelButtonText: "Não",
          }).then(async (rep) => {
            if (rep.isConfirmed) {
              var deletingSwal = this.$swal({
                title: "Cancelando pedido aguarde...",
                html: `
                        <div style="display: flex; flex-direction: column; align-items: center;">
                          <svg width="40" height="40" viewBox="0 0 40 40" style="margin-bottom: 10px;" xmlns="http://www.w3.org/2000/svg" fill="none">
                          <circle cx="20" cy="20" r="18" stroke="#3498db" stroke-width="4" opacity="0.2"/>
                          <circle cx="20" cy="20" r="18" stroke="#3498db" stroke-width="4" stroke-linecap="round"
                            stroke-dasharray="90 60"
                            stroke-dashoffset="0">
                            <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="1s" repeatCount="indefinite"/>
                          </circle>
                          </svg>
                          Aguarde o sistema cancelar o pedido <hr/> <li>${it.prod}</li>
                        </div>
                        `,
                toast: true,
                width: "300px",
                heightAuto: true,
                icon: "info",
                showConfirmButton: false,
                textAlign: "center",
                showButtons: false,
                showCloseButton: false,
              });
              let result = (
                await Pedido.cancelarPedido({
                  cod_pedido: it.cod_pedido,
                  cod_pedido_item: it.cod_pedido_item,
                  empresa: this.empresaSel.codigo,
                })
              ).data;
              if (result.success) {
                deletingSwal.close();
                this.$emit("carregar");
                this.showToast(
                  "success",
                  `Item ${it.prod} duplicado com sucesso!`
                );
              } else {
                alert("erro ao cancelar");
              }
            }
          });
        }
      });
    },
    abrirModalProduto(produto) {
      this.produtoSelecionado = { ...produto };
      this.showModalProduto = true;
    },
    async duplicarPedidoModal(ped) {
      var duplicatingSwal = this.$swal({
        title: "Duplicando aguarde...",
        html: `
        <div style="display: flex; flex-direction: column; align-items: center;">
          <svg width="40" height="40" viewBox="0 0 40 40" style="margin-bottom: 10px;" xmlns="http://www.w3.org/2000/svg" fill="none">
          <circle cx="20" cy="20" r="18" stroke="#3498db" stroke-width="4" opacity="0.2"/>
          <circle cx="20" cy="20" r="18" stroke="#3498db" stroke-width="4" stroke-linecap="round"
            stroke-dasharray="90 60"
            stroke-dashoffset="0">
            <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="1s" repeatCount="indefinite"/>
          </circle>
          </svg>
          Aguarde o sistema duplicar o item <hr/> <li>${ped.prod}</li>
        </div>
        `,
        toast: true,
        width: "300px",
        heightAuto: true,
        icon: "info",
        showConfirmButton: false,
        textAlign: "center",
        showButtons: false,
        showCloseButton: false,
      });

      let result = await Pedido.duplicar({
        cod_pedido: ped.cod_pedido,
        cod_pedido_item: ped.cod_pedido_item,
        empresa: this.empresaSel.codigo,
      });

      console.log("dup result", result);
      this.$emit("carregar");

      duplicatingSwal.close();
      this.showToast("success", `Item ${ped.prod} duplicado com sucesso!`);
      this.showModalProduto = false;
    },
    async cancelarPedidoModal(ped) {
      await this.$swal({
        title: "Confirmação",
        text: "Você tem certeza que deseja cancelar este pedido?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim! Cancelar.",
        cancelButtonText: "Não",
      }).then(async (rep) => {
        if (rep.isConfirmed) {
          var deletingSwal = this.$swal({
            title: "Cancelando pedido aguarde...",
            html: `
            <div style="display: flex; flex-direction: column; align-items: center;">
              <svg width="40" height="40" viewBox="0 0 40 40" style="margin-bottom: 10px;" xmlns="http://www.w3.org/2000/svg" fill="none">
              <circle cx="20" cy="20" r="18" stroke="#3498db" stroke-width="4" opacity="0.2"/>
              <circle cx="20" cy="20" r="18" stroke="#3498db" stroke-width="4" stroke-linecap="round"
                stroke-dasharray="90 60"
                stroke-dashoffset="0">
                <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="1s" repeatCount="indefinite"/>
              </circle>
              </svg>
              Aguarde o sistema cancelar o pedido <hr/> <li>${ped.prod}</li>
            </div>
            `,
            toast: true,
            width: "300px",
            heightAuto: true,
            icon: "info",
            showConfirmButton: false,
            textAlign: "center",
            showButtons: false,
            showCloseButton: false,
          });

          let result = (
            await Pedido.cancelarPedido({
              cod_pedido: ped.cod_pedido,
              cod_pedido_item: ped.cod_pedido_item,
              empresa: this.empresaSel.codigo,
            })
          ).data;

          if (result.success) {
            deletingSwal.close();
            this.$emit("carregar");
            this.showToast(
              "success",
              `Item ${ped.prod} cancelado com sucesso!`
            );
            this.showModalProduto = false;
          } else {
            deletingSwal.close();
            this.showToast("error", "Erro ao cancelar o pedido!");
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btPlus {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  background-color: green;
  color: white;
  border-radius: 50%;
  font-size: 50px;
  margin-top: 20px;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  }
}
.containerPedidosResumo {
  width: 100%;
  height: 10%;
  padding-top: 5px;
  font-size: 16px;

  text-align: center;
  margin-top: 5px;
  font-weight: bolder;
}
.containerPedidos {
  overflow: hidden;
  overflow-y: auto;
  //width: 100%;
  //height: 100%;
  width: 100%;
  height: auto;
  position: absolute;
  top: 0px;
  bottom: 01px;
  overflow: auto;

  padding-bottom: 40px;

  display: flex;
  flex-direction: column;
  padding: 5px;
  padding-bottom: 200px;
  .itemCancelado {
    opacity: 0.8;
    color: red !important;
    text-decoration: line-through;
  }
  .item {
    font-size: 12px;
    border-bottom: 1px dotted rgb(122, 122, 122);
    padding-bottom: 3px;
    padding-top: 3px;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    cursor: pointer;
    &:hover {
      background-color: #f8f8f8;
    }
    .imgs {
      background-color: #f9f9f9;
      width: 70px;
      height: 70px;
      display: flex;
      flex-flow: row wrap;
      div {
        flex: 1;
        background-size: cover;
        height: 100%;
        background-repeat: no-repeat;
        background-position: 50%;
        border-right: 1px solid #d9d9d9;
      }
    }
  }
  .pedido {
    margin-bottom: 5px;

    .item {
      font-size: 12px;
      border-bottom: 1px dotted rgb(122, 122, 122);
      padding-bottom: 3px;
      padding-top: 3px;
      height: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      cursor: pointer;
      transition: all 0.3s ease;
      &:hover {
        // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.4);
        border-left: 2px solid #aaa;
        padding-left: 10px;
      }
    }
  }
  .pedidoCancelado {
    opacity: 0.3;
    color: red;
  }
}

.pedido-produto {
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  .card {
    border-left: 4px solid #28a745;
  }
}

.pedido-item-modal {
  .card {
    border-left: 3px solid #007bff;
  }
}
</style>
